import React, { useState, useEffect, useRef } from 'react';

import Bus from '../../../../assets/images/icones/1onibus.png';
import MultiBus from '../../../../assets/images/icones/3onibus.png';
import BH from '../../../../assets/images/icones/bh.png';


import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, IconsContent, DefaultBox, IconImg, IconImgMulti } from './styles';

interface INavBar {

}



const NossosNumeros: React.FC<INavBar> = () => {
    const [veiculo, setVeiculo] = useState(1);
    const [linhas, setLinhas] = useState(1);
    const [cobertura, setCobertura] = useState(1);
    const targetVeiculo = 2000;
    const targetLinhas = 300;
    const targetCobertura = 100;
    const ref = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);
  
    // Observer
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, []);
  
    // Veículo counter
    useEffect(() => {
      if (!isVisible) return;
      setVeiculo(1);
      const interval = setInterval(() => {
        setVeiculo((prev) => {
          const next = prev + 100;
          return next > targetVeiculo ? targetVeiculo : next;
        });
      }, 100);
      return () => clearInterval(interval);
    }, [isVisible]);
  
    // Linhas counter
    useEffect(() => {
      if (!isVisible) return;
      setLinhas(1);
      const interval = setInterval(() => {
        setLinhas((prev) => {
          const next = prev + 15;
          return next > targetLinhas ? targetLinhas : next;
        });
      }, 100);
      return () => clearInterval(interval);
    }, [isVisible]);
  
    // Cobertura counter
    useEffect(() => {
      if (!isVisible) return;
      setCobertura(1);
      const interval = setInterval(() => {
        setCobertura((prev) => {
          const next = prev + 5;
          return next > targetCobertura ? targetCobertura : next;
        });
      }, 100);
      return () => clearInterval(interval);
    }, [isVisible]);


    return (
        <BaseComp id='num' ref={ref}>
            <BaseContent>
                <TextContent>
                    <TextTitle>
                        <h1>NOSSOS NÚMEROS</h1>
                    </TextTitle>
                    <TextBody>
                        <p>
                            Somos a única empresa de mídia exterior a conseguir 100% de cobertura na cidade de Belo Horizonte com um único formato!
                        </p>
                    </TextBody>
                </TextContent>
                <IconsContent>
                    <DefaultBox>
                        <IconImgMulti src={MultiBus} />
                        <h3 className="growing-text">Linhas</h3>
                        <h1 className="growing-text">+{linhas}</h1>
                    </DefaultBox>
                    <DefaultBox>
                        <IconImg src={Bus} />
                        <h3 className="growing-text">Veículos</h3>
                        <h1 className="growing-text">+{veiculo}</h1>
                    </DefaultBox>
                    <DefaultBox>
                        <IconImg src={BH} />
                        <h3 className="growing-text">Cobertura BH</h3>
                        <h1 className="growing-text">{cobertura}</h1>
                    </DefaultBox>
                </IconsContent>
            </BaseContent>
        </BaseComp>
    );
}

export { NossosNumeros }